module.exports = __webpack_public_path__ + "img/VOLTRAN.8743d1c2.png";